/**
 * User profile and preferences endpoints.
 */
import type { OnboardingData } from '@/types/api';
import { apiClient } from './client';

/**
 * User API endpoints
 */
export const userApi = {
  /**
   * Get current user profile
   */
  getProfile: () => apiClient.get<any>('/users/me'),

  /**
   * Update user profile
   */
  updateProfile: (data: {
    username?: string;
    full_name?: string;
    bio?: string;
  }) => apiClient.put<any>('/users/me', data),

  /**
   * Complete first-time onboarding: persist the learning profile and flip
   * the `onboarded` flag so the OnboardingGate stops redirecting.
   */
  completeOnboarding: (data: OnboardingData) =>
    apiClient.put<any>('/users/me/onboarding', data),

  /**
   * Upload avatar
   */
  uploadAvatar: (file: File) =>
    apiClient.upload<{ avatar_url: string; message: string }>(
      '/users/me/avatar',
      file
    ),

  /**
   * Get user preferences
   */
  getPreferences: () => apiClient.get<any>('/users/me/preferences'),

  /**
   * Update user preferences
   */
  updatePreferences: (data: any) =>
    apiClient.put<any>('/users/me/preferences', data),

  /**
   * Soft-delete (deactivate) the current user's account.
   * The account enters a 30-day recovery window before hard-delete.
   */
  deleteAccount: () =>
    apiClient.delete<{ deleted: boolean; email: string; grace_days: number }>(
      '/users/me'
    ),
};
